export const AREA_CONFIG = [
    {
        code: '886',
        placeholder: '例：0930000000',
        format: (phone: string) =>
            phone.slice(0, 1) !== '0' ? `0${phone}` : phone,
    },
    {
        code: '852',
        placeholder: '例：91011111',
        format: (phone: string) =>
            phone.slice(0, 1) === '0' ? phone.slice(1) : phone,
    },
    {
        code: '853',
        placeholder: '例：68111111',
        format: (phone: string) => phone,
    },
    {
        code: '60',
        placeholder: '例：121111111',
        format: (phone: string) =>
            phone.slice(0, 1) === '0' ? phone.slice(1) : phone,
    },
    {
        code: '65',
        placeholder: '例：90111111',
        format: (phone: string) =>
            phone.slice(0, 1) === '0' ? phone.slice(1) : phone,
    },
]
